import { ApolloError } from '@apollo/client';
import { fetchWhatsAppTemplateMetadataByLocale } from 'api/queries';

import { DocumentNode } from 'graphql';
import { WhatsAppContentDefinition } from 'modules/graphql';
import { useGraphql } from 'utils/hooks/useGraphql';
import { WhatsAppPrimaryContent } from '../types';

export type FetchCampaignByIdQueryRequest = {
  campaignId: number;
};

export type UseQueryWhatsAppTemplateLocaleStatusesResponse = {
  errorMessage?: ApolloError;
  hasError: boolean;
  isLoading: boolean;
  results: {
    templateAndContent: {
      primaryContent?: WhatsAppPrimaryContent;
      localeContents?: WhatsAppContentDefinition[];
    };
  };
};

export function useQueryWhatsAppTemplateLocaleStatuses(
  options: Record<string, any> = {},
  query: DocumentNode = fetchWhatsAppTemplateMetadataByLocale,
): UseQueryWhatsAppTemplateLocaleStatusesResponse {
  const queryOptions = {
    notifyOnNetworkStatusChange: true,
    ...options,
  };

  const {
    data,
    errorMessage,
    isLoading,
    error: hasError = false,
  } = useGraphql(query, queryOptions);

  const results = data ?? {};

  return {
    errorMessage,
    hasError,
    isLoading,
    results,
  };
}
